import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';
import isEmpty from 'lodash/isEmpty';

import SelectField from '../../shared/form-elements/select/field';
import Input from '../../shared/form-elements/input';

const Form = ({
	handleSubmit,
	submitForm,
	intl,
	location_path,
	payoutCurrencies,
	can,
	loadAffiliatesLookup,
	loadGeosLookup,
	resetGeoAndAffiliate,
	loadOffersLookup
}) => {
	const isEditForm = location_path.includes('approve-reject/edit');
	return (
		<div className="form-container approved-reject-form">
			<div className="form-container__head">
				<h2>{ intl(isEditForm ? 'Edit approved-rejected payout' : 'Create approved-rejected payout') }</h2>
			</div>

			<div className="form-container__body">
				<form className="ui-form create-cpl-rule" onSubmit={handleSubmit(data => submitForm(data))}>

					<div className="ui-form__element">
						<Field
							name="offer_id"
							searchable={true}
							placeholder={intl('Offer')}
							multi={false}
							component={SelectField}
							onChange={resetGeoAndAffiliate}
							options={loadOffersLookup}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="geo_id"
							searchable={true}
							placeholder={intl('Geo')}
							multi={false}
							component={SelectField}
							options={loadGeosLookup}
						/>
					</div>

					<div className="ui-form__element">
						<Field
							name="affiliate_id"
							searchable={true}
							placeholder={intl('Affiliate')}
							multi={false}
							component={SelectField}
							options={loadAffiliatesLookup}
						/>
					</div>

					{payoutCurrencies.map((curr, index) =>
						<div className="payouts-container" key={index}>
							<div className="ui-form__element">
								<Field
									name={`${curr}_payout`}
									placeholder={intl(`Payouts ${curr}`)}
									component={Input}
								/>
							</div>
						</div>
					)}

					<div className="ui-form__element buttons">
						{can('approvedRejectPayoutsEdit') &&
							<button className="ui-btn ui-btn-primary">
								{intl('Save')}
							</button>}
						{<Link to="approve-reject/">
							<button type="button" className="ui-btn ui-btn-cancel">
								{intl('Cancel')}
							</button>
						</Link>}
					</div>
				</form>
			</div>
		</div>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func,
	loadOffersLookup: PropTypes.func,
	loadAffiliatesLookup: PropTypes.func
};

const requiredFields = ['geo_id', 'rub_payout', 'usd_payout'];

const validate = values => {
	const errors = {};

	requiredFields.forEach((field) => {
		if (isEmpty(values[field])) {
			errors[field] = 'required';
		}
	});

	return errors;
};

export default reduxForm({
	form: 'approvedRejectPayoutsForm',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/approve-reject/components/form.js